module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workshops-regular",
    class: {
      'scrolled': _vm.windowPageYOffset > 0
    }
  }, [_c('nav-1'), _vm._v(" "), _c('carousel'), _vm._v(" "), _c('timetable'), _vm._v(" "), _c('instagrams'), _vm._v(" "), _c('gift'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action content-text"
  }, [_c('h2', {}, [_vm._v("\n      Get in touch to learn more about our bespoke workshops, or any general enquiries on workshops.\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "mailto:learn@hatopress.net"
    }
  }, [_vm._v("learn@hatopress.net")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05ac0bef","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkshopsRegular.vue
// module id = 204
// module chunks = 1